// extracted by mini-css-extract-plugin
module.exports = {"eventTypeDraft":"#0fb5bd","eventTypePastDue":"#e5004d","eventTypePublished":"#4aa129","eventTypeDefault":"#000","eventTypeDateChangeRequest":"#d9d9d9"};